import React from 'react';
import PropTypes from 'prop-types';

const UpdateCardButton = ({ children, ...props }) => (
  <button
    className="c-btn c-btn--primary"
    type="button"
    {...props}
  >
    {children}
  </button>
);

UpdateCardButton.propTypes = {
  children: PropTypes.node.isRequired,
};

export default UpdateCardButton;



// WEBPACK FOOTER //
// ./src/app/membership/UpdateCustomerInfo/components/UpdateCardButton.jsx